/**
 * Copyright (c) 2018 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import * as consts from '../../const.js';
import { ControlLabel, Form, FormControl, FormGroup, Grid, Row } from 'react-bootstrap';
import { Button } from 'tc-client-common';
import { REASON_DELETE } from '../../const.js';
import Notification from '../common/notification/notification.component';
import DocumentsService, { delete_options } from './documents.service';

class DeleteDocumentComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      reason: ''
    };
    this.changeReasonHandler = this.changeReasonHandler.bind(this);
    this.submit = this.submit.bind(this);
  }

  click(e) {
    e && e.click(); //simulated click to hide the dropdown menu
  }

  changeReasonHandler(event) {
    this.setState({ reason: event.target.value });
  }

  submit = (e) => {
    if (delete_options.pdf === this.props.action) {
      this.props.deletePdf(this.props.consenting, this.state.reason);
    }
    if (delete_options.document === this.props.action || delete_options.entireDocument === this.props.action) {
      this.props.deleteDocument(
        this.props.consenting,
        this.props.participantJourneyGid,
        this.state.reason,
        this.props.action
      );
    }
    e.preventDefault();
  };

  render() {
    let error = '';
    if (this.props.deleteDocumentError) {
      error = <Notification type="error" data={this.props.deleteDocumentError} />;
    }
    return (
      <div>
        {error}
        <Form horizontal id="delete-document-form" onSubmit={this.submit}>
          <Grid id="delete-pdf-grid" fluid>
            <Row>
              <div ref={this.click} id="delete-document-name">
                <i className="material-icons description-icon">insert_drive_file</i>
                {DocumentsService.buildDocumentFullName(
                  this.props.consenting.consentName,
                  this.props.consenting.documentVersion
                )}
              </div>
            </Row>
            <Row>
              <FormGroup controlId="reason">
                <ControlLabel>
                  {REASON_DELETE} <span>*</span>
                </ControlLabel>
                <FormControl
                  componentClass="textarea"
                  id="reason"
                  value={this.state.reason}
                  onChange={this.changeReasonHandler}
                  required
                />
              </FormGroup>
            </Row>
          </Grid>
          <div className="edit-modal-footer">
            <hr className="edit-modal-divider" />
            <Button
              id="delete-document-cancel-button"
              type="reset"
              theme="default large-button"
              handleClick={this.props.close}
              label={consts.CANCEL_BTN}
            />
            <Button
              id="delete-document-button"
              theme="secondary large-button"
              type="submit"
              label={consts.DELETE_BTN}
            />
          </div>
        </Form>
      </div>
    );
  }
}

export default DeleteDocumentComponent;
